export const domainUrl = "https://api.hairplusinternational.com/api";
// export const domainUrl = process.env.REACT_APP_DOMAIN_URL
// export const loginDomain = process.env.REACT_APP_IDENTITY_URL
// export const userloginDomain = process.env.REACT_APP_LOGIN_URL
